import React from "react";
import styled, { ThemeProvider } from "styled-components";
import Fade from 'react-reveal/Fade';

const WrapperCard = styled.div`
  text-align: center;

  img {
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
    /* box-shadow: -5px -5px 10px #ffffff; */
    padding: 10px;
  }

  .tagname {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.theme.background} ;
    box-shadow: -10px -10px 15px #ffffff;
    border-radius: 10px;
    opacity: 1;
    margin-top: 5px;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
    width: 95%;
    height: 80px;
    font-size: 28px;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;

    @media screen and (max-width: 1200px) {
      font-size: 20px;
      width: 95%;
      height: 60px;
    }

    @media screen and (max-width: 768px) {
      font-size: 16px;
      width: 95%;
      height: 55px;
    }

    @media screen and (max-width: 637px) {
      font-size: 14px;
      height: 45px;
    }
  }
`;

const colorTheme = {
  live22: {
    background:
      "transparent linear-gradient(180deg, #0396ff 0%, #0080db 100%) 0% 0% no-repeat padding-box",
    color: "#0396ff",
  },
  slotxo: {
    background:
      "transparent linear-gradient(180deg, #E40203 0%, #960E10 100%) 0% 0% no-repeat padding-box",
    color: "#E40203",
  },
  pgslot: {
    background:
      "transparent linear-gradient(180deg, #28BC7B 0%, #3DB741 100%) 0% 0% no-repeat padding-box",
    color: "#28BC7B",
  },
  joker: {
    background:
      "transparent linear-gradient(180deg, #FF12A4 0%, #DA0055 100%) 0% 0% no-repeat padding-box",
    color: "#FF12A4",
  },
  ambslot: {
    background:
      "transparent linear-gradient(180deg, #E59801 0%, #FAEB57 100%) 0% 0% no-repeat padding-box",
    color: "#FFB503",
  },
};

const CardBannerComponent = ({ data, pageName }) => {
  return (
    <ThemeProvider theme={colorTheme[pageName]}>
      <WrapperCard className="grid grid-cols-2 sm:grid-cols-1 mt-5">
        {data.map((items, index) => (
          <Fade bottom key={index}>
            <div className="block">
              <img src={items.image.url} alt="" />
              <div className="tagname">{items.title}</div>
            </div>
          </Fade>
        ))}
      </WrapperCard>
    </ThemeProvider>
  );
};

export default CardBannerComponent;
